import script from "./TBaseInput.vue?vue&type=script&lang=js"
export * from "./TBaseInput.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__